export default function WithdrawCompletePage() {
    return (
      <div className="max-w-xl mx-auto my-24 text-center">
        <h1 className="text-2xl font-bold mb-4">退会が完了しました</h1>
        <p className="text-gray-700">ご利用ありがとうございました。またのご利用をお待ちしております。</p>
      </div>
    );
  }